import { REPOSITORY_LABELS_SCENARIOS } from '@/features/Transition360/Labels/documentLabelFixtures';
import { useDocumentLabelsController } from '@/features/Transition360/Labels/useDocumentLabelsController';
import { RepositoryTab } from '@/features/Transition360/Repository/RepositoryTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const repositorySearchSchema = z.object({
    scenario: z.enum(REPOSITORY_LABELS_SCENARIOS).optional().catch(undefined),
    tags: z.array(z.string().min(1)).optional().catch(undefined),
});

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/repository',
)({
    validateSearch: repositorySearchSchema,
    component: RepositoryTabRoute,
});

function RepositoryTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    const { scenario, tags } = Route.useSearch();
    const navigate = Route.useNavigate();
    const documentLabels = useDocumentLabelsController(scenario ?? 'review');
    return (
        <RepositoryTab
            projectId={projectId}
            projectAssetId={projectAssetId}
            documentLabels={documentLabels}
            tagFilter={tags ?? []}
            onTagFilterChange={(next) =>
                navigate({
                    search: (previous) => ({
                        ...previous,
                        tags: next.length ? [...new Set(next)] : undefined,
                    }),
                })
            }
        />
    );
}
